import { useLocation } from 'react-router-dom';
import { MenuConfig } from 'src/constants/menu';
import Collapse from '@dynamika-shared/ui/Collapse/Collapse';
import { SectionTab } from './SectionTab';
import { MenuSubSection } from './MenuSubSection';
import { twJoin } from '@utils/twMerge';
import { icons } from '@dynamika-shared/ui/icons';
import { FC } from 'react';

type MenuSectionProps = {
  item: MenuConfig;
  menuIndex: number;
  sideBarCollapsed: boolean;
};

export const MenuSection = ({
  item,
  menuIndex,
  sideBarCollapsed,
}: MenuSectionProps) => {
  const location = useLocation();
  const active =
    location.pathname === item.path ||
    location.pathname.startsWith(item.path + '/');

  const Icon = icons[item.icon as keyof typeof icons];

  return (
    <li
      data-testid={'MenuSection-' + item.name}
      className={twJoin(menuIndex > 0 ? 'mt-1.5' : '')}
    >
      {item?.children && !sideBarCollapsed && (
        <Collapse
          open={active}
          styles={{
            header: twJoin(
              'rounded-md pl-2 pr-1.5 py-[1rem] mb-1',
              active && 'bg-waterLight'
            ),
            icon: 'text-pastelBlue w-2 h-2',
          }}
          label={
            <SectionTab
              icon={Icon as unknown as FC<{ className?: string }>}
              active={active}
              title={item.title}
              sideBarCollapsed={sideBarCollapsed}
              disabled={item.disabled}
            />
          }
        >
          <ul className=''>
            {item.children.map(({ name, path, title, disabled }) => (
              <MenuSubSection
                name={name}
                key={name}
                path={path}
                title={title}
                disabled={disabled}
              />
            ))}
          </ul>
        </Collapse>
      )}
      {(!item?.children || sideBarCollapsed) && (
        <div
          className={twJoin(
            'flex cursor-pointer rounded-md px-2 py-[1rem]',
            active && 'bg-waterLight'
          )}
        >
          <SectionTab
            icon={Icon as unknown as FC<{ className?: string }>}
            path={item.path}
            active={active}
            title={item.title}
            sideBarCollapsed={sideBarCollapsed}
            disabled={item.disabled}
          />
        </div>
      )}
    </li>
  );
};
